import ApiResponse from "@/server/responses/ApiResponse";
import User from "@/server/structures/User";

export default class ApiResponse_GetUser extends ApiResponse {

    get user() {
        return new User(this._rawResponse.data);
    }
}
